const fieldLengths = {
  nameOnCard: 40,
  firstName: 50,
  lastName: 80,
  email: 80,
  password: 50,
  addressLineOne: 80,
  addressLine2: 50,
  city: 40,
  postalCode: 9,
};

export default fieldLengths;
